import styled from 'styled-components';

export const DescriptionContainerBox = styled.span`
    width: 100%;
    font-size: 12px;
    font-family: ${props => props.theme.font.family.body};
    color: ${props => props.theme.colors.textMiddleDark};
`;